export default "__VITE_PUBLIC_ASSET__afe95ac4__"